const handleModalClose = event => {
  if ($('.modal.show').length) {
    nifty.body.addClass('modal-open');
  }
};

function MultiModalCloseHandler() {
  nifty.body.on('hidden.bs.modal', '.modal', handleModalClose);
  nifty.body.on('shown.bs.modal', '.bootbox', event => {
    $(event.currentTarget).one('hidden.bs.modal', handleModalClose);
  });
}

exports.init = MultiModalCloseHandler;
